<template>
  <v-container fluid>
    <!-- <v-breadcrumbs :items="items">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs> -->
    <div id="app ">
      <div style="display:flex; justify-content: space-between;">
        <!-- <v-col cols="11"> -->
        <Breadcrumb class="row justify-content-center mt-4" />
        <!-- </v-col> -->
        <span v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </span>
      </div>
    </div>
    <v-data-table
      ref="theDataTable"
      :headers="headersData"
      :items="operatorsData"
      :search="search"
      :items-per-page="15"
      @pagination="pagination = $event"
      :mobile-breakpoint="0"
      fixed-header
      height="400px"
      border-bottom="5px"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="50"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class=""
                    fab
                    small
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="white">icon-download</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-divider></v-divider>

                  <v-list>
                    <v-list-item>
                      <v-list-item-action>
                        <vue-json-to-csv
                          :json-data="dataDownload"
                          :csv-title="'Alerts Data'"
                        >
                          <v-btn color="indigo" dark style="">
                            CSV
                          </v-btn>
                        </vue-json-to-csv>
                      </v-list-item-action>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-action>
                        <v-btn @click="createPDF" color="indigo" dark
                          >PDF
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
              <v-btn
                :disabled="disablewhileProcessing"
                class="mr-2 ml-4"
                small
                fab
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="addDoc()"
              >
                <v-icon>icon-add</v-icon>
              </v-btn>
            </template>
            <!-- changes -->
            <v-form ref="form">
              <v-card>
                <v-card-title class="background-blue">
                  <span class="text-h5 icon-white">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                        :disabled="disableMachine"
                          :items="machineItems"
                          v-model="editedItem.machine_id"
                          prepend-icon="icon-dpimm"
                          @change="assignparam($event)"
                          label="Select Machines(s)*"
                          item-text="machine_name"
                          item-value="id"
                          :rules="selectedItemsRules"
                          required
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="4">

                        <v-autocomplete
                          :disabled=" disableParameter"                          
                          :items="parameters"
                          v-model="editedItem.parameter_id"
                          prepend-icon="icon-cog-single"
                          label="Operational Parameter*"
                          item-text="parameter_name"
                          item-value="parameter_id"
                          :rules="selectedItemsRules"
                          required
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                          v-on:click="getAlluserData()"
                          label="Users*"
                          :items="userSelectiondata"
                          item
                          prepend-icon="icon-role"
                          v-model="editedItem.userSelection"
                          item-value="user_id"
                          item-text="user_name"
                          required
                          multiple
                          :rules="selectedItemsRules"
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <label class="radiolabel">Enable</label>
                        <v-radio-group
                          v-model="editedItem.enable_flag"
                          row
                          class="radiogroup"
                        >
                          <v-radio
                            label="Yes"
                            value="Y"
                            @change="changeActivestatus('Y')"
                          ></v-radio>
                          <v-radio
                            label="No"
                            value="N"
                            @change="changeActivestatus('N')"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <label class="radiolabel">Send SMS*</label>
                        <v-radio-group
                          v-model="editedItem.sms_enable_flag"
                          row
                          class="radiogroup"
                        >
                          <v-radio
                            label="Yes"
                            value="Y"
                            :disabled="disablewhileProcessing"
                            @change="changeActiveSMSstatus('Y')"
                          ></v-radio>
                          <v-radio
                            label="No"
                            value="N"
                            :disabled="disablewhileProcessing"
                            @change="changeActiveSMSstatus('N')"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <label class="radiolabel">Send Email*</label>
                        <v-radio-group
                          v-model="editedItem.email_enable_flag"
                          row
                          class="radiogroup"
                        >
                          <v-radio
                            label="Yes"
                            value="Y"
                            :disabled="disablewhileProcessing"
                            @change="changeActiveEmailstatus('Y')"
                          ></v-radio>
                          <v-radio
                            label="No"
                            value="N"
                            :disabled="disablewhileProcessing"
                            @change="changeActiveEmailstatus('N')"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="6" sm="6" md="3">
                        <v-text-field
                          v-model="editedItem.low_alert"
                          prepend-icon="icon-low-alert"
                          label="Low Alert"
                          @keypress="onlyNumber"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="3">
                        <v-text-field
                          v-model="editedItem.high_alert"
                          prepend-icon="icon-high-alert"
                          label="High Alert"
                          @keypress="onlyNumber"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6" sm="6" md="3">
                        <v-text-field
                          v-model="editedItem.low_caution"
                          label="Low Caution"
                          @keypress="onlyNumber"
                          prepend-icon="icon-low-caution"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="3">
                        <v-text-field
                          v-model="editedItem.high_caution"
                          label="High Caution"
                          prepend-icon="icon-high-caution"
                          @keypress="onlyNumber"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions class="pb-5">
                  <v-spacer></v-spacer>
                  <v-btn rounded color="#FE000C" @click="close">
                    <v-icon left class="icon-white">icon-cancel</v-icon>
                    <span style="color: white;"> Cancel</span>
                  </v-btn>
                  <v-btn rounded color="primary" @click="submitForm()">
                    <v-icon left>icon-availability</v-icon>
                    Submit
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.status="{ item }">
        <v-switch
          color="indigo"
          @change="changeStatus(item, item.status)"
          :disabled="disablewhileProcessing"
          false-value="N"
          true-value="Y"
          v-model="item.enable_flag"
        ></v-switch>
      </template>
      <template v-slot:item.sms_enable_flag="{ item }">
        <v-switch
          color="indigo"
          @change="changeStatus(item, item.status)"
          :disabled="disablewhileProcessing"
          false-value="N"
          true-value="Y"
          v-model="item.sms_enable_flag"
        ></v-switch>
      </template>
      <template v-slot:item.email_enable_flag="{ item }">
        <div style="display: flex; justify-content: center;">
          <v-switch
            color="indigo"
            @change="changeStatus(item, item.status)"
            :disabled="disablewhileProcessing"
            false-value="N"
            true-value="Y"
            v-model="item.email_enable_flag"
          ></v-switch>
        </div>
      </template>

      <template
        v-slot:item.actions="{ item }"
        :disabled="disablewhileProcessing"
      >
        <v-icon small class="mr-2" @click="editItem(item)">
          icon-action
        </v-icon>
      </template>
      <!-- <template v-slot:no-data>
        <v-btn color="primary" @click="setGridData"> Reset </v-btn>
      </template> -->
    </v-data-table>
    <div id="sucessAlert">
      <v-alert outlined type="success" text>
        Data Saved successfully.
      </v-alert>
    </div>
    <div id="errorAlert">
      <v-alert outlined type="warning" prominent border="left">
        Error while saving the data.
      </v-alert>
    </div>
  </v-container>
</template>
<script>
import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";

import axios from "axios";
// import constants from "../constants";
import VueJsonToCsv from "vue-json-to-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import router from "../router";
// const logo = require("../assets/trinitiimage.png");

export default {
  components: {
    VueJsonToCsv,
    Breadcrumb,
    LoaderProgress,
  },

  data: () => ({
    disableParameter: false,
    disableMachine: false,
    disablewhileProcessing: false,
    userSelectiondata: [],
    userSelection: null,
    alertValue: [(v) => !!v || "Input is required"],
    phoneNumberRules: [
      (v) => !!v || "Phone number is required",
      (v) =>
        /^\d{10}$/.test(v) ||
        "Invalid phone number format (10 digits required)",
    ],
    emailRules: [
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid",
    ],
    selectedItemsRules: [(v) => !!v || "At least one option must be selected"],
    // selectedItemsRules: [
    //     v => (Array.isArray(v) && v.length > 0) || 'You must select at least one item'],
    showLoader: false,
    isEdit: false,
    machineItems: [],
    parameters: [],
    dataDownload: [],
    // search: "",
    headersData: [],
    operatorsData: [],
    userNames: [],

    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    switch1: true,
    menu: false,
    items: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },
      {
        text: "Admin Menu",
        disabled: true,
        href: "/",
      },
      {
        text: "Configuration for Alerts / Notifications",
        disabled: true,
      },
    ],
    search: "",
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "User Name",
        value: "machine_name",
        sortable: true,
      },
      {
        text: "Machine",
        align: "start",
        sortable: true,
        value: "machine",
      },
      {
        text: "Operational Parameter",
        align: "start",
        sortable: true,
        value: "operationalparameter",
      },
      {
        text: "Threshold Value",
        align: "start",
        sortable: true,
        value: "thresholdvalue",
      },
      {
        text: "Low Alert",
        align: "start",
        sortable: true,
        value: "lowalert",
      },
      {
        text: "High Alert",
        align: "start",
        sortable: true,
        value: "highalert",
      },
      {
        text: "Low Caution",
        align: "start",
        sortable: true,
        value: "lowcaution",
      },
      {
        text: "High Caution",
        align: "start",
        sortable: true,
        value: "highcaution",
      },
      // {
      //   text: "Email Detail",
      //   align: "start",
      //   sortable: true,
      //   value: "emaildetail",
      // },
      // {
      //   text: "Phone Number",
      //   align: "start",
      //   sortable: true,
      //   value: "phonenumber",
      // },
      {
        text: "Status",
        align: "start",
        sortable: true,
        value: "enable_flag",
      },
      {
        text: "Send SMS",
        align: "start",
        sortable: true,
        value: "sms_enable_flag",
      },
      {
        text: "Send Email",
        align: "start",
        sortable: true,
        value: "email_enable_flag",
      },
      { text: "Action", value: "actions", sortable: false },
    ],
    oeemonitoring: [],
    editedIndex: -1,
    editedItem: {
      userSelection: null,
      id: null,
      machine_id: "",
      parameter_id: "",
      // threshold_value: "",
      low_alert: null,
      low_caution: null,
      high_alert: null,
      high_caution: null,
      email: "",
      phone_number: "",
      enable_flag: "Y",
      sms_enable_flag: "Y",
      email_enable_flag: "Y",
    },
    defaultItem: {
      parameter_id: "",
      machine_id: "",
      // threshold_value: "",
      low_alert: null,
      low_caution: null,
      high_alert: null,
      high_caution: null,
      email: "",
      phone_number: "",
      enable_flag: "Y",
      sms_enable_flag: "Y",
      email_enable_flag: "Y",
    },
    machine: ["Option 1", "Option 2", "Option 3", "Option 4", "Option 5"],
    operationalparameter: [
      "Option 1",
      "Option 2",
      "Option 3",
      "Option 4",
      "Option 5",
    ],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add New" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.setGridData();
    this.setMachineData();
    this.getAlluserData();
  },

  methods: {
    getAlluserData() {
      try {
        let config = {
          method: "get",
          url: `${this.$config.backend_url}/getAllUserData`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
        this.noteLastAPICallTime();
        axios(config).then((response) => {
          console.log("response.dataresponse.data ", response.data);
          this.userSelectiondata = response.data.data;
        });
      } catch (error) {
        window.alert("Internal Error");
      }
    },

    submitForm() {
      console.log(
        "this.editedItem.userSelection",
        this.editedItem.userSelection
      );
      if (this.$refs.form.validate()) {
        // console.log(this.$refs.form.validate())
        // Form is valid, submit data
        this.save();
      } else {
        console.log(this.$refs.form.validate());
        this.dialog = true;

        // Form is invalid, display error message
      }
    },
    addDoc() {
      this.disableMachine = false
      this.disableParameter =true
      this.isEdit = false;
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    changeActivestatus(item) {
      document.querySelector("#errorAlert").style.display = "none";
      console.log("checking enabled flag", item);
      this.editedItem.enable_flag = item;
    },
    changeActiveEmailstatus(item) {
      document.querySelector("#errorAlert").style.display = "none";
      console.log("checking SMS enabled flag", item);
      this.editedItem.email_enable_flag = item;
    },
    changeActiveSMSstatus(item) {
      document.querySelector("#errorAlert").style.display = "none";
      console.log("checking Email enabled flag", item);
      this.editedItem.sms_enable_flag = item;
    },
    createPDF() {
      let content = this.$refs["theDataTable"];
      console.log("pagination", this.pagination);
      let doc = new jsPDF("landscape");
      doc.text(14, 7.5, "Alerts/Notifications Configuration");
      doc.addImage(
        this.getImgUrl1(this.$config.image_inside_pdf),
        "png",
        this.$config.first_dimension_separate_again,
        this.$config.second_dimension_separate,
        this.$config.third_dimension_separate,
        this.$config.fourth_dimension_separate_again
      );
      let columnHeaders = [
        "user name",
        "Machine(s)",
        "Operational Parameter",
        // "Threshold Value",
        "Low Alert",
        "High Alert",
        "Low Caution",
        "High Caution",
        // "eMail",
        // "Phone Number",
        "Status",
      ];
      let rows = [];
      content.items.forEach((data, index) => {
        console.log(data, "bjsbchkbkJCNBWJKHEI");
        if (
          index >= this.pagination.pageStart &&
          index < this.pagination.pageStop
        ) {
          let tempRow = [
            data.user_name || "",
            data.machine_name || "",
            data.parameter_name || "",
            // data.threshold_value || "",
            data.low_alert || "",
            data.high_alert || "",
            data.low_caution || "",
            data.high_caution || "",
            data.enable_flag === "Y" ? "On" : "Off",
          ];
          rows.push(tempRow);
        }
      });
      doc.setFontSize(9);
      doc.autoTable(columnHeaders, rows, { startY: 11.5 });
      let d = new Date();
      doc.save(
        `Alerts_Notifications_Config ${d.toISOString().slice(0, 10) +
          " " +
          d
            .toTimeString()
            .split("(")[0]
            .slice(0, -1)}.pdf`
      );
    },
    setMachineData() {
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getMachineNames`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          console.log("response--getMachineNames", response.data);
          let machineData = response.data.data;
          machineData.sort((first_machine, second_machine) => {
            return this.compareObjects(
              first_machine,
              second_machine,
              "machine_name"
            );
          });
          console.log("cehcking machine dayta=>", machineData);
          this.machineItems = machineData;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });

      // this.selectProps = ["Nozzle Temperature","Z1 Temperature"]
    },

    assignparam(event) {
      // let machineID = event;
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getParametersData?machine_id=${event}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          // console.log("response--parameter names", response.data.data);
          this.parameters = [];
          let parametersList = response.data.data|| [];
          if (!this.disableMachine && parametersList.length != 0 )
          {
            this.disableParameter=false

          }
          parametersList.sort((first_operator, second_operator) => {
            return this.compareObjects(
              first_operator,
              second_operator,
              "parameter_name"
            );
          });
          this.parameters = parametersList;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    changeStatus(item, status) {
      console.log("checking item and status", item, status);
      let updated_user = sessionStorage.getItem("activeUser") || "";
    
      this.disablewhileProcessing = true;
      const req = {
        id: item.id,
        machine_id: item.machine_id,
        parameter_id: item.parameter_id,
        updated_by: updated_user,
        // threshold_value: item.threshold_value,
        low_alert: item.low_alert,
        high_alert: item.high_alert,
        low_caution: item.low_caution,
        high_caution: item.high_caution,
        // email: item.email,
        // phone_number: item.phone_number,
        enable_flag: item.enable_flag,
        sms_enable_flag: item.sms_enable_flag,
        email_enable_flag: item.email_enable_flag,
      };
      const allElementsAreNumbers = arr => arr.every(val => typeof val === 'number');
      const confirm = allElementsAreNumbers(item.user_id)

      if (!confirm)
      {
        const dictListToIntList = item.user_id.map(dict => parseInt(Object.values(dict)[0]));

        req['user'] = dictListToIntList

      }
      else
      {
        req['user'] =item

      }

      console.log("checking reqad item", req, item);
      this.showLoader = true;
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/UpdateAlertsData`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";
            this.setGridData();
            this.disablewhileProcessing = false;
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            console.log("axios error", error.message);
            this.disablewhileProcessing = false;
          }
        });
    },
    setGridData: function() {
      this.headersData = [
        {
          text: "User Name",
          value: "username_list",
          sortable: true,
        },
        {
          text: "Machine",
          value: "machine_name",
          align: "start",
          sortable: true,
        },
        {
          text: "Operational  Parameter",
          value: "parameter_name",
          sortable: true,
        },

        // {
        //   text: "Threshold Value",
        //   value: "threshold_value",
        //   class: "indigo--text subtitle-1",
        // },
        {
          text: "Low Alert",
          value: "low_alert",
          sortable: true,
        },
        {
          text: "High Alert",
          value: "high_alert",
          sortable: true,
        },
        {
          text: "Low Caution",
          value: "low_caution",
          sortable: true,
        },
        {
          text: "High Caution",
          value: "high_caution",
          sortable: true,
        },
        // {
        //   text: "eMail Details",
        //   value: "email",
        //   sortable: true,
        // },
        // {
        //   text: "Phone Number",
        //   value: "mobile",
        //   sortable: true,
        // },
        { text: "Status", value: "status", sortable: true },
        { text: "Send SMS", value: "sms_enable_flag", sortable: true },
        { text: "Send Email", value: "email_enable_flag", sortable: true },

        { text: "Actions", value: "actions", sortable: true },
      ];
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getAlertsData`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.showLoader = true;

      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          console.log("checking customers=>", response.data.data);
          this.operatorsData = response.data.data || [];
          let result = [];

          for (let i in response.data) result.push([i, response.data[i]]);
          console.log("checking result data=>", result[0][1]);
          this.dataDownload = result[0][1];
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;

          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else if (
            error.response &&
            error.response.status === 400 &&
            error.response.data.message ===
              "This Password is not allowed, Choose different password."
          ) {
            alert(error.response.data.message);
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },

    editItem(item) {
      console.log("checking editing items",this.disableParameter,this.disableMachine)
      this.assignparam(item.machine_id);
      this.disableParameter =  true
      this.disableMachine =true
      this.isEdit = true;
      console.log("svvbsvsv", item);
      this.editedIndex = this.operatorsData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.editedItem.userSelection = item.user_id;

      console.log("znvhdsuvusu", item.user_id);
      console.log("znvhdsuvusu", this.editedItem.userSelection);
    },

    close() {
      this.dialog = false;
      console.log("kkkkkkkkkkkkkkkkkkkkkkkkkkk", this.dialog);

      this.$refs.form.resetValidation();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      console.log("save callse");
      console.log("checking dATA", this.editedItem.userSelection);
      let result = [];




      console.log(
        "checking result",
        result,

      );
      let updated_user = sessionStorage.getItem("activeUser") || "";
      let user = sessionStorage.getItem("activeUser") || "";
      let req = {
        id: this.isEdit ? this.editedItem.id : undefined,
        machine_id: this.editedItem.machine_id,
        created_by: this.isEdit ? undefined : user,
        updated_by: this.isEdit ? updated_user : undefined,
        parameter_id: this.editedItem.parameter_id,
        //number of user selected from frontend, accordingly that many users data of  email and phone has been configure for notification and alert
        // user:  this.editedItem.userSelection,
        enable_flag: this.editedItem.enable_flag,
        sms_enable_flag: this.editedItem.sms_enable_flag,
        email_enable_flag: this.editedItem.email_enable_flag,

        low_alert: this.editedItem.low_alert,
        low_caution: this.editedItem.low_caution,
        high_alert: this.editedItem.high_alert,
        high_caution: this.editedItem.high_caution,
      };
      const allElementsAreNumbers = arr => arr.every(val => typeof val === 'number');
      const confirm = allElementsAreNumbers(this.editedItem.userSelection)

      if (!confirm)
      {
        const dictListToIntList = this.editedItem.userSelection.map(dict => parseInt(Object.values(dict)[0]));

        req['user'] = dictListToIntList

      }
      else
      {
        req['user'] =this.editedItem.userSelection

      }
      console.log("checking request data", req);
      let url = this.isEdit
        ? `${this.$config.backend_url}/UpdateAlertsData`
        : `${this.$config.backend_url}/AlertsDataEntry`;
      this.showLoader = true;
      let config = {
        method: "post",
        url: url,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          this.$refs.form.resetValidation();
          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";
            this.setGridData();
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            console.log("axios error", error.message);
          }
        });
      this.close();
    },
  },
};
</script>
<style scoped>
#sucessAlert {
  display: none;
}
#errorAlert {
  display: none;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row) {
  border-right: thin solid rgba(0, 0, 0, 2) !important;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-right: thin solid rgba(0, 0, 0, 2);
}
</style>
